import { useState } from "react";
import { onboardingPlanData, OnboardingPlanEnum } from "../../../../../assets/utils/data/onboarding";
import { PlanCard, PlanLabel, PlanWrapper } from "../../../../auth/onboarding/steps/plan-step";
import { OnboardingBodyItemsBlock } from "../../../../auth/onboarding/steps/structure-step";
import { LabelText, LargeHeadline, LittleSubHeadline, LittleText, NotificationText, SubHeadline } from "../../../../../components/typography";
import doneIcon from '../../../../../assets/images/icons/done-dark-icon.svg'
import { Button } from "../../../../../components/ui/button";
import { COLORS } from "../../../../../assets/utils/enums/colors";
import MainLayout from "../../../../../components/layout/layout";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

export default function PlansLitsPage() {
    const navigate = useNavigate();
    const [currentPlan, setCurrentPlan] = useState<string>(onboardingPlanData[2].title);
    return (
        <PlanBlock className="w-100">
            <SubHeadline>Тарифні плани</SubHeadline>
            <LabelText className="py-2">Оберіть тариф, який найкраще відповідає потребам вашої команди</LabelText>
            <Button
                bgcolor={"transparent"}
                txtcolor={COLORS.secondary1}
                brcolor={COLORS.secondary1}
                width="auto"
                brradius="24px"
                type="small"
                style={{ borderWidth: "2px" }}
                onClick={() => navigate(-1)}
                className="back-btn"
            >
                <NotificationText className="fw-bold">Назад</NotificationText>
            </Button>
            <OnboardingBodyItemsBlock className="pt-3">
                {onboardingPlanData.map((item) => {
                    const isActive = currentPlan === item.title as OnboardingPlanEnum;
                    return (
                        <PlanWrapper $active={isActive}>
                            {item.label && (
                                <PlanLabel>
                                    {item.label}
                                </PlanLabel>
                            )}

                            <PlanCard
                                $active={isActive}
                            >
                                <span className="d-flex flex-column">
                                    <LittleSubHeadline>{item.title}</LittleSubHeadline>
                                    <LittleText>{item.description}</LittleText>

                                    <span className="d-flex align-items-end gap-1 pt-2">
                                        <LargeHeadline>
                                            {item.price} {item.currency.symbol}
                                        </LargeHeadline>
                                        <LabelText>/ {item.time}</LabelText>
                                    </span>
                                </span>

                                <span className="d-flex flex-column gap-3">
                                    {item.items.map((text, index) => (
                                        <span key={index} className="d-flex align-items-start gap-2">
                                            <img src={doneIcon} alt="done-icon" />
                                            <NotificationText>{text}</NotificationText>
                                        </span>
                                    ))}
                                </span>

                                <Button
                                    bgcolor={isActive ? COLORS["half-gray"] : COLORS.secondary1}
                                    txtcolor={`${COLORS.white} !important`}
                                    brcolor={isActive ? COLORS["half-gray"] : COLORS.secondary1}
                                    width="auto"
                                    brradius="24px"
                                    type="small"
                                    onClick={() => setCurrentPlan(item.title as OnboardingPlanEnum)}
                                >
                                    <NotificationText>{isActive ? "Поточний план" : "Обрати"}</NotificationText>
                                </Button>
                            </PlanCard>
                        </PlanWrapper>
                    );
                })}

            </OnboardingBodyItemsBlock>
            <NotificationText className="disclaimer-text">Без прихованих платежів. Скасування в один клік</NotificationText>
        </PlanBlock>)
}

const PlanBlock = styled(MainLayout)`
display: flex;
flex-direction: column;
align-items: center;
    ${SubHeadline}, ${LabelText} {
        color: ${COLORS.secondary1};
    }
    ${OnboardingBodyItemsBlock} {
        width: 85%;
    }
    ${PlanCard} {
        ${Button} {
                position: sticky;
    top: 100%;
}
}
.back-btn {
        position: absolute;
        top: 15%;
        left: 90%;
    }
`